<template>
    <v-dialog v-model="show" max-width="1200px">
        <v-card>
            <v-card-title>Product Preview<v-spacer></v-spacer>
                <v-btn text small @click.stop="show=false"><i class="fa fa-times" aria-hidden="true"></i></v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <div class="single-product-content pa-5">
                    <v-row>
                        <v-col md="4">

                            <v-carousel hide-delimiters height="auto">
                                <v-carousel-item v-for="(item,i) in images" :key="i" :src="item.src">
                                </v-carousel-item>
                            </v-carousel>


                        </v-col>
                        <v-col md="8">
                            <h2>{{name}}</h2><br>
                            <p>{{ description }}</p>
                            <div>
                                <strong>HSN/ SAC Code: </strong>
                                {{ hsn_sac_code }}
                            </div>
                            <div>
                                <strong>Price: Rs.</strong>
                                {{ sale_price }}
                                <span v-if="unit">per {{ unit.toLowerCase() }}</span>
                            </div>
                            <div v-if="taxPercentage != 'None' 
                                                || taxPercentage != '0% GST' || taxPercentage != '0% IGST' ">
                                <strong>Tax: </strong>
                                {{ taxPercentage }}
                            </div>
                            <div>
                                <strong>Discount: Rs.</strong>
                                {{ discountAmount }}
                            </div>
                            <div v-if="taxPercentage != 'None' 
                                                || taxPercentage != '0% GST' || taxPercentage != '0% IGST' 
                                                || discountAmount!=0 ">
                                <strong>Final Price: Rs.</strong>
                                {{ final_price }}
                            </div>
                            <div>
                                <strong>Minimum order quantity</strong>
                                {{ minimum_order_quantity }}
                                <span v-if="unit"> {{ unit.toLowerCase() }}</span>
                            </div>
                            <!-- <div>
                                                <strong>Order Quantity: </strong>
                                                <v-text-field outlined dense ref="quantity" v-model="quantity"
                                                    label="quantity" placeholder="quantity" @keyup="checkAvailability"
                                                    class="mt-4"></v-text-field>
                                                <span v-if="unit"> {{ unit.toLowerCase() }}</span>
                                            </div> -->
                            <div v-if="is_buyer">
                                <v-row>
                                    <v-col cols="3" class="d-flex justify-start my-2">
                                        <strong>Order Quantity: </strong>
                                    </v-col>
                                    <v-col cols="4" class="d-flex align-start">
                                        <v-text-field dense placeholder="quantity" outlined @keyup="checkAvailability"
                                            ref="quantity" v-model="quantity"></v-text-field>
                                    </v-col>
                                    <v-col cols="5" class="d-flex justify-start my-2">
                                        <span v-if="unit"> {{ unit.toLowerCase() }}</span>
                                    </v-col>
                                </v-row>
                            </div>
                 
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
            <v-divider class="mt-12"></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click.stop="show=false">Close</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
    // import VueSlickCarousel from 'vue-slick-carousel'
    // import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    // optional style for arrows & dots
    // import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

    export default {
        name: 'ProductPreview',
        components: {
            // VueSlickCarousel 
        },
        props: {
            value: Boolean
        },
        data() {
            return {
                images: [],
                name: null,
                description: null,
                products: [],
                total: 0,
                order_quantity: 0,

                // NEW FIELDS
                stock: 0,

                minimum_order_quantity: 0,
                sale_price: 0,
                final_price: 0,
                unit: null,
                totalQuantity: 0,
                discount: 0,
                discountAmount: 0,
                hsn_sac_code: null,
                taxPercentage: 0,
                taxType:null,
                // NEW FIELDS
            }
        },
        computed: {
            show: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },
        methods: {
            validate() {

            }
        },
        created() {},
        watch: {
            value(visible) {
                if (visible) {

                    this.images = [],
                        this.name = null,
                        this.description = null,
                        this.products = [],
                        this.total = 0,
                        this.order_quantity = 0,

                        this.$store.dispatch('previewProductDetails', 1)
                        .then((res) => {
                            if (res.data.data) {
                                console.log("POP UP PREVIEW DATA", res.data.data)
      
                                this.name = res.data.data[0].name
                                this.description = res.data.data[0].description

                                this.stock = res.data.data[0].stock
                            this.minimum_order_quantity = res.data.data[0].minimum_order_quantity
                            this.hsn_sac_code = res.data.data[0].hsn_sac_code

                            this.sale_price = res.data.data[0].sale_price
                            let tax_percentage = 0
                            if (res.data.data[0].tax_percentage == 'None') {
                                tax_percentage = 0;
                                this.taxPercentage = 'None'
                            } else if (res.data.data[0].tax_percentage == 'GST @ 0%') {
                                tax_percentage = 0;
                                this.taxPercentage = '0% GST'
                            } else if (res.data.data[0].tax_percentage == 'IGST @ 0%') {
                                tax_percentage = 0;
                                this.taxPercentage = '0% IGST'
                            } else if (res.data.data[0].tax_percentage == 'GST @ 0.25%') {
                                tax_percentage = 0.25 / 100;
                                this.taxPercentage = '0.25% GST'
                            } else if (res.data.data[0].tax_percentage == 'GST @ 12%') {
                                tax_percentage = 12 / 100;
                                this.taxPercentage = '12% GST'
                            } else if (res.data.data[0].tax_percentage == 'GST @ 18%') {
                                tax_percentage = 18 / 100;
                                this.taxPercentage = '18% GST'
                            }

                            if (res.data.data[0].tax_type == 'Excluding Tax') {
                                this.final_price = parseFloat(this.sale_price) + parseFloat(tax_percentage) *
                                    parseFloat(this.sale_price)
                            } else if (res.data.data[0].tax_type == 'Including Tax') {
                                this.taxPercentage = parseFloat(tax_percentage) * parseFloat(this.sale_price)
                                this.final_price = this.sale_price
                            }

                            if (res.data.data[0].discount_type == 'Percentage') {
                                this.discount = parseFloat(this.sale_price) - parseFloat(this.sale_price) *
                                    parseFloat(res.data.data[0].discount_amount / 100)
                                this.discountAmount = parseFloat(this.sale_price) * parseFloat(res.data.data[0]
                                    .discount_amount / 100)
                            } else if (res.data.data[0].discount_type == 'Amount') {
                                this.discount = parseFloat(this.sale_price) - parseFloat(res.data.data[0]
                                    .discount_amount)
                                this.discountAmount = parseFloat(res.data.data[0].discount_amount)
                            }

                            this.final_price = this.final_price - this.discountAmount
                            this.discount = this.discount.toFixed(2)
                            this.final_price = this.final_price.toFixed(2)
                            this.discountAmount = this.discountAmount.toFixed(2)

                            this.unit = res.data.data[0].unit


                                for (let i = 0; i < res.data.data[0].photos.length; i++) {
                                    this.images.push({
                                        src: res.data.data[0].photos[i].photo_url
                                    })
                                }
                    
                            }
                        })
                        .catch(err => {
                            console.log(err)
                        })
                } else {
                    console.log("Dialog was closed!")
                }
            }
        },
        mounted() {
            //console.log(this.logo)
        }
    }
</script>

<style>
    /* If the screen size is 601px wide or more */
    @media screen and (min-width: 601px) {
        .home h2 {
            font-size: 37px;
        }

        .home h5 {
            font-size: 16px;
            ;
        }
    }

    /* If the screen size is 600px wide or less */
    @media screen and (max-width: 600px) {
        .home h2 {
            font-size: 20px;
        }

        .home h5 {
            font-size: 10px;
            ;
        }
    }
</style>